import { Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function HomeGetStarted() {
  return (
    <Container fluid className="getstarted-container w-100 mt-5">
      <div className="homeContent">
        <h1>Ready to get started?</h1>

        <Link to="/signup" className="applyhere mt-4">
          Apply Here
        </Link>
      </div>
    </Container>
  );
}
